import * as yup from 'yup';

const re = /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/gm

export const profileFormValidationSchema = yup.object().shape({
  firstName: yup.string().defined().required(),
  lastName: yup.string().defined().required(),
  phone: yup.string().defined().required(),
  portfolio: yup.string().nullable().notRequired().when('portfolio', {
    is: (value) => value?.length,
    then: (rule) => rule.matches(re),
  }),
  email: yup.string().required().email(),
  availability: yup.boolean().required(),
  price: yup.number().required().max(9000).min(10)
}, [['portfolio', 'portfolio']])

export interface ProfileModalForm {
  firstName: string
  lastName: string
  portfolio: string
  phone: string
  email: string
  availability: boolean
  price: number
}

